const activeThreadIdStorageKey = "salesko.agent.activeThreadId";

type ActiveThreadIdStorage = Pick<Storage, "getItem" | "setItem">;

export function readStoredActiveThreadId(
  storage: ActiveThreadIdStorage | undefined = browserLocalStorage()
): string | null {
  const value = storage?.getItem(activeThreadIdStorageKey);
  return value && value.trim().length > 0 ? value : null;
}

export function writeStoredActiveThreadId(
  threadId: string,
  storage: ActiveThreadIdStorage | undefined = browserLocalStorage()
) {
  storage?.setItem(activeThreadIdStorageKey, threadId);
}

function browserLocalStorage(): ActiveThreadIdStorage | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}
